
import {createSlice} from "@reduxjs/toolkit";


export const dataPointSlice = createSlice({
    name: 'dataPointSlc',
    initialState: {value: {id: 0, mcode: "", name: "", description: "", dataType: null, piiClassifiation: null,allowMany: null,
            dpDrawerState: false, dpDrawerMode: null, dpGridRefresh: false,
            dpxListId: 0, dpxListDrawerState: false,
            csfListId: 0, csfListDrawerState: false,
            dpuListId: 0, dpuListDrawerState: false,
            expressionListId: 0, expressionListDrawerState: false,
            cdpvListId: 0, cdpvListDrawerState: false
     }},
    reducers:

{
    changeDataPoint: (state, action) => {
        state.value = {
            ...state.value,  // Keep existing fields
            ...action.payload // Merge new values
        };
    }
}
});

export const { changeDataPoint } = dataPointSlice.actions;

export default  dataPointSlice.reducer ;
